/*
 * @LastEditors: liangen(80398513)
 * @FilePath: \cem-portal-frontend\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import '@/utils/sensors'
import sensors from '@/utils/sensors'
import 'normalize.css/normalize.css'
import App from './App'
import i18n from '@/locales/index'
import router from './router'
import store from './store'
import Cookie from 'js-cookie'
import GCommonUI from '@gcommon/gcommon-ui'
import '@gcommon/gcommon-ui/lib/theme-chalk/icon.css'
import '@/assets/styles/gcommon-ui.scss'
import VueCompositionAPI from '@vue/composition-api'
import '@/assets/js/dragula.min.css'
import '@/assets/js/dragula.min.js'
import '@/assets/font/customIcon/iconfont.css'
import '@/assets/styles/root.scss'
import locale from '@gcommon/gcommon-ui/lib/locale/lang/en'
import PortalVue from 'portal-vue'
import * as FlycodeUpload from '@gcommon/flycode-upload'
import '@/utils/config'

import { initialize } from '@heytap/cloud-observation-rum'

initialize({
  collectionSourceUrl: [
    'cem-test.wanyol.com',
    'cem-survey-test.wanyol.com'
  ].includes(window.location.hostname)
    ? 'https://ums-telemetry-test.wanyol.com'
    : 'https://ums-telemetry.oppoer.me',
  serviceName: 'cem-portal-frontend'
})

Vue.use(VueCompositionAPI)
Vue.use(GCommonUI, {
  locale,
  i18n: (key, value) => i18n.t(key, value),
  supportCook: true
})
Vue.use(PortalVue)
Vue.use(FlycodeUpload)
Vue.config.productionTip = false
Vue.prototype.$env = window.env

// 错误日记收集、监控、上报
Vue.config.errorHandler = function (err, vm, info) {
  sensors.track('cem_error', {
    cem_err: err,
    cem_vm: vm,
    cem_info: info
  })
}

if (import.meta.env.MODE === 'development') {
  Cookie.set(
    'SIAMTGT',
    'TGT-30178-rfw2OmGOSbDy9i9GZZcfXlLSa7mrd1qOHOBzQHfdcQlNaKuaDR-SIAM'
  )
}

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')

// const root = document.documentElement
// if (
//   window.matchMedia &&
//   window.matchMedia('(prefers-color-scheme: dark)').matches
// ) {
//   root.style.setProperty('--dark-normal-bg-color', '#fff3cc')
//   root.style.setProperty('--dark-active-bg-color', 'red')
// } else {
//   root.style.setProperty('--dark-normal-bg-color', '#fff3cc')
//   root.style.setProperty('--dark-active-bg-color', 'red')
// }
